<template>
  <div class="fixed-bg">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4 position-relative text-right">
        <!-- <div id="slider">
          <img src="../../assets/img/brand/drlWhiteBg.png" alt="DRL" />
        </div> -->
      </div>
      <div class="col-md-8 light-bg">
        <div class="contentWrap">
        <h1>Research, Monitor, and Act on Municipal Bonds with Confidence</h1>
        <div class="loginWrap">
          <!-- <img src="../../assets/img/brand/logoBlack.svg" alt="DRL" /> -->
            <img
                    src="../../assets/img/brand/BondLogix_Stacked.png"
                    class="bondlogix-logo"
                  />  
          <!-- <h3>TRADEBOOK</h3> -->
          <p>Welcome back, Please login to your account.</p>
          <form role="form">
            <div class="form-group mb-3">
              <div class="input-group input-group-merge input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fa fa-envelope-open" aria-hidden="true"></i>
                  </span>
                </div>
                <input class="form-control" placeholder="Username" v-model="username" />
              </div>
            </div>
            <div class="form-group">
              <div class="input-group input-group-merge input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                  </span>
                </div>
                <input
                  class="form-control"
                  placeholder="Password"
                  :type="showPassword ? 'text' : 'password'"
                  v-model="password"
                />
                  <!-- Toggle Button -->
                <div class="input-group-append" @click="showPassword = !showPassword" style="cursor:pointer;">
                  <span class="input-group-text">
                    <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                  </span>
                </div>
              </div>
            </div>
            <br />
            <div v-if="error.message" class="alert alert-danger" role="alert">
              <i class="fas fa-exclamation-triangle"></i>
              {{error.message}}
            </div>
            <div class="text-center">
              <button  type="submit" class="btn btn-primary my-2" @click="login"  :disabled="loading" >
                LOGIN
                <i v-if="!loading" class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                <i v-if="loading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
              </button>
            </div>
            <a href="javascript:void(0);" @click="forgotPassword" class="text-light">
              <small>Forgot password?</small>
            </a>
            <!-- <button class="btn access-request">Request Access Now</button> -->
             <a class="access-request-tag" href="mailto:drl@drlgroup.net?subject=Please%20activate%20my%20login%20on%20the%20DRL%20Group%20Muni%20Offerings%20&amp;%20Research%20Platform" target="_blank">Request Access Now</a>
          </form>
        </div>
        <div class="sbFooter">
          <p>Office: <a href="tel:1-281-398-8600">(281) 398-8600</a> | &nbsp; &nbsp; Toll Free: <a href="tel:1-866-664-4040">(866) 664-4040</a> |  &nbsp; &nbsp; Email: <a href="mailto:drl@drlgroup.net">drl@drlgroup.net</a></p>
        </div>
        </div>
        <div class="loginFooter">
          <p>
    Securities offered through NewEdge Securities, LLC, member FINRA and SIPC. The DRL Group is not a subsidiary or control affiliate of NewEdge Securities, LLC. NewEdge Securities, Inc. has no affiliation to BondDesk Trading LLC or BondTrader Pro, or Tradeweb Direct, Bondpoint, TMC, Market Axess or any ECN.<br><br>
    Do not buy discount bonds based on the Yield-to-Call (YTC). Yield to call (YTC) is not indicative of total return; this yield is valid only if the security is called. Bonds may or may not be called, or be callable on multiple dates or, in other cases, called any date following the first call date, so yield to call is based on the earliest stated call date. Discounted bonds may be subject to capital gains tax. Bonds may be subject to OID (Original Issue Discount). Bonds could also be subject to the DeMinimis Rule, please consult your tax advisor for further clarification. Insured bonds are issued for timely payment of principal and interest only. Insured bonds do not cover potential market loss and are subject to the claims paying ability of the insurance company. Municipal income may be subject to state, local, and Alternative Minimum Tax (AMT) taxation. Corporate and Municipal securities are subject to gains/losses based on the level of interest rates, market conditions, and credit quality of the issuer. Non-rated (NR), With-Drawn (WR), or below investment grade bonds, and lower-rated bonds carry a greater potential risk of default and should be considered by sophisticated investors only.<br><br>
    Prices and availability may change at any time without notice. The securities described herein may not be eligible for sale in all jurisdictions or to specific categories of investors.<br><br>
    This summary is for informational purposes only and is not an offer or solicitation for the purchase or sale of any security or a recommendation or endorsement of any security or issuer. NewEdge Securities, LLC. and DRL Group make no representation about the accuracy, completeness, or timeliness of this information.<br><br>
    This report does not regard any recipient's specific investment objectives, financial situation, or needs and is based on information obtained from sources believed to be reliable. No independent verification has been made, nor is its accuracy or completeness guaranteed. Opinions expressed herein are subject to change without notice. The division, group, subsidiary, or affiliate of NewEdge Securities, LLC, is under no obligation to update or keep the information current. NewEdge Securities, LLC accepts no liability for any loss or damage of any kind arising out of the use of this report. Contact your tax advisor regarding the suitability of tax-exempt investments in your portfolio. This document is for informational purposes only and does not replace or serve as a substitute for your official monthly statement generated by NFS. Please refer to your official statement for accurate and comprehensive account details.<br><br>
    Reminder: E-mails sent through the internet are not secure. Do not use e-mail to send us personal confidential information. Do not e-mail time sensitive instructions or trade orders. This e-mail is not an official trade confirmation for transactions executed in your account. Your e-mail message is not private; it is subject to review by the firm, its officers, agents, and employees. Unless expressly stated in this e-mail, nothing in this message should be construed as a digital or electronic signature.
</p><br>

<p>
    We take protecting your data and privacy very seriously. You can revoke your consent to receive emails at any time by using the SafeUnsubscribe® link, found at the bottom of every email.
</p><br>

<p>©2026 The DRL Group. All Rights Reserved. <a href=https://www.drlgroup.net/privacy-policy/ target="_blank">Privacy Policy</a></p>

 

      </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import cognitoAuth from "@/cognito";
import authService from "@/authService";
//import this.$http from "this.$http";
import config from "@/config";

export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      error: {},
      loading: false,
      showPassword: false
    };
  },
  methods: {
    /**
     * Login  
     * param {Object} e - Event Object to prevent default form submission
     */
    login(e) {
      e.preventDefault();
      this.error = { message: "" };
      if (this.username != "" && this.password != "") {
        this.loading = true;
        var self = this;
        /*eslint: no-unused-vars: "off"*/
        /**
         * Login with AWS 
         * param {Object} username - username from input
         * param {Object} password - password from input
         */
        this.$cognitoAuth.authenticate(
          this.username.trim(),
          this.password,
          (err,session) => {
            if (err) {
              console.log("errormsg",err);
              if(err.code == "CodeMismatchException" || err.code == "InvalidParameterException"){
                this.error = { message: "Invalid verification code"};
                this.loading = false;
                return
              }
              if(err.message == "User is disabled." ){
                this.error = { message: "Your account has been deactivated. Please contact the administrator."};
              }else{
                this.error = { message: "Username or password is incorrect"};
              }
              this.loading = false;
            } else {
              var accessToken = session.getIdToken().getJwtToken();
              if(!session.getIdToken().payload['cognito:groups']){
                this.error = { message: "User group is not assigned. Please contact the administrator."};
                self.loading = false;
                self.$cognitoAuth.logout();
                return
              }
              var userGroup   = session.getIdToken().payload['cognito:groups'];
              // Convert the array to a set to remove duplicates, then convert it back to an array
              const uniqueArray         =  [...new Set(userGroup.map(item => item.split('-')[0].toLowerCase()))];
              var userOrganizations     =  uniqueArray.join(',');
              //console.log("Group",session.getIdToken().payload['cognito:groups'])
              /** 
               * Get Organization token after successful login  
               * param {String} accessToken - accessToken from AWS session
               * param {String} userGroup   - one of the user group name eg: Drl-Trader
               * param {Function} function  - call back function will trigger after got response
               */
              this.getOrgTokenFromServer(accessToken,userOrganizations,function(error,result){
                if(error){
                  self.loading = false;
                  self.$cognitoAuth.logout();
                }else{
                  // Set organisation token in local storage for further use.
                  const drlObject = result.organizations[0]
                  const drlOrgToken = drlObject ? drlObject.orgToken : null;
                  console.log(drlOrgToken)
                  authService.setOrgToken(drlOrgToken);
                  // Set module array(BidSide Or TradeRecap) in local storage for further use.
                  authService.setModule(result.modules);
                  authService.setUserOrganization(result.organizations);

                  /**
                   * Get user   
                   * param {String} accessToken - accessToken from AWS session
                   * param {String} result.orgtoken   - organisation token from getOrgTokenFromServer API
                   * param {String} orgtoken,session.getIdToken().payload['sub']   - sub id from user session 
                   * param {Object} session  - current user session
                   */  
                  self.getUser(accessToken,drlOrgToken,session.getIdToken().payload['sub'],session);
                }
               
              })
            }
          },
          newPass => {
            if (newPass) {
              //console.log("login error 2");
            }
          }
        );
      } else {
        console.log("2");
        this.error = { message: "Username and password are required." };
      }
    },
    forgotPassword() {
      window.location.href = "/forgotpassword";
    },
    /**
     * Redirect to dashboard after succesful login   
     * param {Boolean} isAdmin - is logged user is admin or not.If Admin need to redirect admin dashboard
     */ 
    redirectToDashboard(isAdmin,userRoles){
      // console.log(isAdmin,userRoles)
      // Get current modules from local storage
      var modules = authService.getModule();
      // console.log(modules)
      
      var user = authService.getUser();

      if(modules.length > 0){
        if(userRoles.includes('Client') && user.phone){
          this.$router.push("client/dashboard");
          return false;
        } 
         if(userRoles.includes('Client') && !user.phone){
          this.$router.push("client/updateclient");
          return false;
        } 
        if(userRoles.includes('RiskManager')){
          this.$router.push("/dashboardoption");
          return false;
        } 
        if(modules.length > 1){
          this.$router.push("/dashboardoption");
          return false;
        }
        if(modules[0] == 'BidSide'){
          if(userRoles.length == 1 && userRoles[0] == 'SuperAdmin' ){
            this.$router.push("/bidside/admin-users");
            return false;
          }
          if(isAdmin){
            this.$router.push("/bidside/admin-dashboard");
            return false; 
          }else{
            this.$router.push("/bidside/trader-dashboard");
            return false;
          }
         
        }
        if(modules[0] == 'TradeRecap'){
          this.$router.push("/dashboard");
          return false;
        }
        if(modules[0] == "AutoBidder"){
          this.$router.push("/brockerdealer/brockerdealercapitalsettings");
          return false;
        }
      }else{
        this.$cognitoAuth.logout();
      }
    },
    setUserAsActive(user,accessToken,orgToken){
      const auth = {
        headers: { authorization: accessToken ,'org-token' : orgToken }
      };
      let data =  {
          "id":user.id,
          "status":"ACTIVE"
          }
      this.$http
        .put(
           config.baseUrlBidSide +
            "/user/status",
            data,
            auth
        ).then(() => {
          console.log("User status updated to active")
        })
    },
    getUser(accessToken,orgToken,cognitoSub,session){
      const auth = {
        headers: { authorization: accessToken ,'org-token' : orgToken }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user?cognitoSub="+
            cognitoSub,
            auth
        )
        .then(result => {

          //Set user details in localstorage
          authService.setUser(result.data);
          //Get user Roles(User groups in AWS) and Map roles array , Remove text before hyphen. Example Drl-Admin to Admin
          var userRoles = session.getIdToken().payload['cognito:groups'].map(item => { return  item.split("-")[1] });
          //this.getUserOrganizations(accessToken,orgToken,userRoles)
          this.loading = false;
          this.redirectToDashboard(userRoles.includes('Admin') || userRoles.includes('Editor'),userRoles);
          //Redirect to dashborad 
          
           if(result.data.status == "INVITED"){
            // Handle invited user logic
            this.setUserAsActive(result.data,accessToken,orgToken);
          }

        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;
          this.$cognitoAuth.logout();

        });
    },
    getOrgTokenFromServer(accessToken,userGroup,cb){
        const auth = {
            headers: { authorization: accessToken }
          };
        this.$http
        .get(
            config.baseUrlBidSide +
            "/group/org?orgs="+userGroup,
            auth
        )
        .then(result => {
            cb(null,result.data)
        })
        .catch(e => {
            console.log(e);
            cb(e)

        });
    },
    getUserOrganizations(accessToken,orgToken,userRoles){
        const auth = {
            headers: { authorization: accessToken ,'org-token' : orgToken }
          };
        this.$http
        .get(
            config.baseUrlAutoBidder +
            "/user/orgs?userId="+authService.getUser().id,
            auth
        )
        .then(result => {
          authService.setUserOrganization(result.data.organizations);
          this.loading = false;
          this.redirectToDashboard(userRoles.includes('Admin') || userRoles.includes('Editor'),userRoles);

        })
        .catch(e => {
            console.log(e);
        });
    }
  },
  created() {
    //If the user is already logged in redirect to dashborad 
    this.loading = true;
    //cognitoAuth.logout();

    cognitoAuth.isAuthenticated((session, loggedIn) => {
      if (loggedIn) {
        if(!session.getIdToken().payload['cognito:groups']){
          this.loading = false;
          this.$cognitoAuth.logout();
          return
        }
        //Get user Roles(User groups in AWS) and Map roles array , Remove text before hyphen. Example Drl-Admin to Admin
        var userRoles = session.getIdToken().payload['cognito:groups'].map(item => { return  item.split("-")[1] });
        //console.log(userRoles)
        //Redirect to dashborad                
        this.redirectToDashboard(userRoles.includes('Admin') || userRoles.includes('Editor'),userRoles);
      }else{
        if(localStorage.getItem("userLastSeen")){
          localStorage.removeItem("userLastSeen");
        }
      }
      this.loading = false;
    });
    
  }
};
</script>
<style scoped>
.access-request-tag{
  display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    color: #FF8B82;
    border: 1px solid #FF8B82;
    font-size: 15px;
    padding: 6px 20px;
    font-weight: 400;
    margin: 20px auto 0 !important;
    background-color: rgba(0, 0, 0, 0.2);
    text-decoration: none;
    width: fit-content;
}
.access-request-tag:hover{
  background-color: #FF8B82;
  color: #fff;
  border: 1px solid #FF8B82;
}
</style>

